import React from "react";
import { AuthProvider } from "./pages/AuthContext";
import { PopupProvider } from "./components/PopupProvider";
import RouteConfig from "./routes";
import "./pages/styles.css";

function App() {
  return (
    <div className="app">
      <PopupProvider>
        <AuthProvider>
          <div className="app-content">
            <RouteConfig />
          </div>
        </AuthProvider>
      </PopupProvider>
    </div>
  );
}

export default App;
